import { Divider } from 'antd'
import InfoCards from 'components/InfoCards'
import WorkIcon from 'components/icons/WorkIcon'
import {
  CardRow,
  PaddedDiv,
  PaddedDivContent,
  PaddedDivContentLeft,
  SectionWrapper,
  TopHeading,
} from 'modules/Roles/Style/style'
import { getSingleRoleData } from 'modules/Roles/actions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import ApplicationIcon from '../../../../components/icons/ApplicationIcon'
import FresherIcon from '../../../../components/icons/FresherIcon'
import { permittedCruds } from '../../../../utils/permissionsValidation'
import DoughtChart from './Style/Chart'
import ExpDoughtChart from './Style/Exp-Chart'

const StyledInstituteText = styled.span`
  color: #808697;
  font-size: 12px;
  font-weight: 500;
`
const ViewRoleChart = ({
  roleViewChartData,
  roleViewCardDataATS,
  singleRoleData,
  jobId,
  permissions,
}) => {
  const params = useParams()
  const dispatch = new useDispatch()
  useEffect(() => {
    dispatch(getSingleRoleData(0,params?.jobId))
  }, [params?.jobId])

  const cruds = permittedCruds(permissions, 'ROLES')
  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <TopHeading>Applications</TopHeading>
        <CardRow>
          {cruds?.includes('TOTAL APPLICATIONS') && (
            <div style={{ width: '100%' }}>
              <InfoCards
                icon={<ApplicationIcon />}
                text={'Total Applications'}
                clickIcon={roleViewCardDataATS?.totalCandidate > 0}
                onCardClick={roleViewCardDataATS?.totalCandidate > 0}
                navigation={`/roles/${jobId}/applicant-tracking-system`}
                value={
                  roleViewCardDataATS?.totalCandidate
                    ? roleViewCardDataATS?.totalCandidate
                    : '0'
                }
              />
            </div>
          )}
          {cruds?.includes('FRESHERS') && (
            <div
              style={{
                pointerEvents: 'auto',
                width: '100%',
              }}
            >
              <InfoCards
                icon={<FresherIcon />}
                text={'Freshers'}
                onCardClick={true}
                value={
                  <>
                    {roleViewCardDataATS?.totalInstituteCount}{' '}
                    <StyledInstituteText>Institutes</StyledInstituteText>{' '}
                    <span
                      style={{
                        borderRight: '1px solid #E6E7EA',
                        marginTop: '4px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    ></span>{' '}
                    {roleViewCardDataATS?.studentCount}{' '}
                    <StyledInstituteText>Students</StyledInstituteText>
                  </>
                }
                clickIcon={true}
                navigation={`/roles/${jobId}/view-role`}
              />
            </div>
          )}
          {cruds?.includes('EXPERIENCED CANDIDATES') && (
            <div
              style={{
                pointerEvents:
                  singleRoleData.jobTypeLevels?.[0] === 'ENTRY'
                    ? 'none'
                    : 'auto',
                width: '100%',
              }}
            >
              <InfoCards
                icon={<WorkIcon />}
                text={'Experienced Candidate'}
                value={
                  roleViewCardDataATS?.expCandidateConut
                    ? roleViewCardDataATS?.expCandidateConut
                    : '0'
                }
                clickIcon={roleViewCardDataATS?.expCandidateConut > 0}
                onCardClick={roleViewCardDataATS?.expCandidateConut > 0}
                navigation={`/roles/${jobId}/ex-student`}
              />
            </div>
          )}
        </CardRow>
      </PaddedDiv>
      <div style={{ display: 'flex', gap: '40rem', marginLeft: '6rem' }}>
        <div>
          <TopHeading>Drives</TopHeading>
        </div>
        <div>
          <TopHeading> Experienced Candidate In Drive</TopHeading>
        </div>
      </div>
      <CardRow>
        <PaddedDivContentLeft>
          <DoughtChart roleViewChartData={roleViewChartData} />
        </PaddedDivContentLeft>
        <Divider
          type="vertical"
          style={{ height: '30rem', marginLeft: '6%' }}
        />
        <PaddedDivContent>
          <ExpDoughtChart roleViewChartData={roleViewChartData} />
        </PaddedDivContent>
      </CardRow>
    </SectionWrapper>
  )
}

export default ViewRoleChart
